module.exports = __webpack_public_path__ + "img/tiktokLogo.6c1544ec.svg";